import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: 'Natalia P.',
    location: 'San Luis',
    time: '12 minutos'
  });
  const buyers = [{
    name: 'Natalia P.',
    location: 'San Luis',
    time: '12 minutos'
  }, {
    name: 'Romina G.',
    location: 'CABA',
    time: '25 minutos'
  }, {
    name: 'Julieta M.',
    location: 'Córdoba',
    time: '1 hora'
  }, {
    name: 'Silvana R.',
    location: 'Santa Fe',
    time: '3 horas'
  }, {
    name: 'Marcela T.',
    location: 'Mendoza',
    time: '45 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle through showing and hiding
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        setBuyer(randomBuyer);
        setIsVisible(true);
      }, 15000); // Wait 15s before showing next
    }, 20000); // 5s visible + 15s hidden = 20s cycle
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-329">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -50
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 pr-10 max-w-xs flex items-start gap-3" data-id="element-330">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-331">
            <CloseIcon sx={{
          fontSize: 16
        }} data-id="element-332" />
          </button>

          <div className="bg-green-100 rounded-full p-1 flex-shrink-0 mt-1" data-id="element-333">
            <CheckCircleIcon className="text-brand-green" fontSize="small" data-id="element-334" />
          </div>

          <div data-id="element-335">
            <p className="text-xs text-brand-green font-bold mb-1 uppercase tracking-wide" data-id="element-336">
              Compra verificada
            </p>
            <p className="text-sm text-brand-dark font-medium leading-tight mb-1" data-id="element-337">
              {buyer.name} de {buyer.location}
            </p>
            <p className="text-sm text-brand-gray mb-1" data-id="element-338">
              compró Miga Master Pro 🥖
            </p>
            <p className="text-xs text-gray-400" data-id="element-339">hace {buyer.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}